<template>
  <sub-page title="个人就业困难人员认定信息查询">
    <div class="query-page">
      <!-- 状态横幅 -->
      <div class="status-banner">
        <svg viewBox="0 0 24 24" class="banner-icon"><path d="M12 2 L21 7 L21 13 C21 18 17 21.5 12 22.5 C7 21.5 3 18 3 13 L3 7 Z" fill="none" stroke="#07A35A" stroke-width="2" stroke-linejoin="round"/><path d="M8.5 12 L11 14.5 L16 9.5" fill="none" stroke="#07A35A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <div class="banner-text">
          <div class="banner-title">您已被认定为就业困难人员</div>
          <div class="banner-sub">认定信息在有效期内，可按规定享受就业扶持政策</div>
        </div>
      </div>

      <div class="info-list">
        <div class="info-item" v-for="(item, idx) in infoList" :key="idx">
          <span class="info-label">{{ item.label }}</span>
          <span class="info-value">{{ item.value }}</span>
        </div>
      </div>

      <div class="tips-box">
        <div class="tips-title">温馨提示</div>
        <div class="tips-line">1. 就业困难人员认定有效期为 3 年，到期后需重新申请认定；</div>
        <div class="tips-line">2. 已实现单位就业、退休或不再符合认定条件的，认定自动注销；</div>
        <div class="tips-line">3. 如有疑问，请拨打人社咨询热线 12333。</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'HardshipInfoQuery',
  components: { SubPage },
  data() {
    return {
      infoList: [
        { label: '姓名', value: '戴义杰' },
        { label: '证件号码', value: '3411**********5619' },
        { label: '就业困难流水号', value: 'JK202403110076' },
        { label: '困难类型', value: '连续失业6个月以上人员' },
        { label: '月均收入', value: '0 元' },
        { label: '审核标志', value: '已审核' },
        { label: '就困有效标志', value: '有效' },
        { label: '认定日期', value: '2024-03-11' },
        { label: '有效期至', value: '2027-03-10' },
        { label: '认定机构', value: '南京市江北新区社会事业局' },
        { label: '政策', value: '社保补贴、岗位补贴、免费职业介绍与职业培训、优先推荐就业' }
      ]
    }
  }
}
</script>

<style scoped>
.query-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.status-banner {
  display: flex;
  align-items: center;
  gap: calc(20 * var(--w));
  margin: calc(20 * var(--w)) calc(24 * var(--w)) 0;
  background: #E9F9F0;
  border-radius: calc(12 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
}
.banner-icon {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  flex-shrink: 0;
}
.banner-title {
  font-size: calc(32 * var(--w));
  font-weight: bold;
  color: #07A35A;
  margin-bottom: calc(6 * var(--w));
}
.banner-sub {
  font-size: calc(24 * var(--w));
  color: #4E8A6B;
}
.info-list {
  background: #fff;
  margin: calc(20 * var(--w)) calc(24 * var(--w)) 0;
  border-radius: calc(12 * var(--w));
  overflow: hidden;
}
.info-item {
  display: flex;
  align-items: center;
  min-height: calc(100 * var(--w));
  padding: calc(12 * var(--w)) calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.info-item:last-child {
  border-bottom: none;
}
.info-label {
  font-size: calc(28 * var(--w));
  color: #969799;
  white-space: nowrap;
  width: calc(260 * var(--w));
  flex-shrink: 0;
}
.info-value {
  flex: 1;
  font-size: calc(28 * var(--w));
  color: #323233;
  text-align: right;
}
.tips-box {
  margin: calc(24 * var(--w));
  background: #FFFBEF;
  border-radius: calc(12 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.tips-title {
  font-size: calc(28 * var(--w));
  font-weight: bold;
  color: #B07A1E;
  margin-bottom: calc(8 * var(--w));
}
.tips-line {
  font-size: calc(26 * var(--w));
  color: #8A6D3B;
  line-height: 1.9;
}
</style>



// WEBPACK FOOTER //
// src/pages/HardshipInfoQuery.vue